// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"Jb-z","pointsSection":"Kb-z","goToDashboard":"Lb-z"};